module.exports = __webpack_public_path__ + "static/media/month-coupon.6689b212.png";